import { useMutation, useQueryClient } from "@tanstack/react-query";
import useUserStore from "@/modules/users/store";
import { updateLicenciadaTheme } from "../firestore";

type ThemePayload = {
  primary?: string;
  secondary?: string;
  accent?: string;
  [key: string]: string | undefined;
};

/**
 *
 */
function useUpdateLicenciadaTheme() {
  const queryClient = useQueryClient();
  const activeLicenciadaId = useUserStore((state) => state.activeLicenciadaId);

  return useMutation({
    mutationFn: async (payload: ThemePayload) => {
      if (!activeLicenciadaId) {
        throw new Error("Licenciada ativa não encontrada");
      }
      return updateLicenciadaTheme(activeLicenciadaId, payload);
    },
    onSuccess: (_data, _variables) => {
      if (activeLicenciadaId) {
        void queryClient.invalidateQueries({ queryKey: ["licenciada", activeLicenciadaId] });
      }
    }
  });
}

export default useUpdateLicenciadaTheme;
